export const AUTH_PATH = '/auth';
export const USERS_PATH = '/users';
export const BACKEND_URL = 'http://192.168.0.165:5002';
